import type { LabelsMap } from '.';
import type { PersonalPageFamily } from '../subtypes/types';

export const PERSONAL_PAGE_FAMILY_LABELS: LabelsMap<PersonalPageFamily> = {
  campaign: {
    singular: 'דף התרמה',
    plural: 'דפי התרמה',
    gender: 'male',
    definiteArticle: 'lastExceptFirst'
  },
  event: {
    singular: 'דף אירוע',
    plural: 'דפי אירועים',
    gender: 'male',
    definiteArticle: 'lastExceptFirst'
  },
  information: {
    singular: 'דף מידע ופניות',
    plural: 'דפי מידע ופניות',
    gender: 'male',
    definiteArticle: 'lastExceptFirst'
  }
};
